import { IWizardStep } from "../../../../wizard/types";
import Content from "./Content";

export const viewContentConfig: IWizardStep = {
  width: "568px",
  titleConfig: {
    titleText: "View academic",
    info: "You can see all the completed data but you can not edit them.",
  },
  content: Content,
};
